var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBolt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-bolt",
    d: "M9.39492236,4.12 C9.30916635,3.94833333 9.18053234,3.8625 9.00902032,3.8625 L5.62165804,3.8625 L6.00756007,0.90125 C6.05043808,0.729583333 5.92180406,0.515 5.75029205,0.472083333 C5.57878004,0.38625 5.36439002,0.429166667 5.23575601,0.600833333 L0.947955648,5.75083333 C0.862199641,5.87958333 0.819321637,6.05125 0.905077644,6.22291667 C0.990833651,6.35166667 1.11946766,6.4375 1.29097968,6.4375 L4.67834196,6.4375 L4.29243993,9.39875 C4.24956192,9.57041667 4.37819594,9.785 4.54970795,9.82791667 C4.59258595,9.87083333 4.67834196,9.87083333 4.72121996,9.87083333 C4.84985397,9.87083333 4.97848799,9.82791667 5.06424399,9.69916667 L9.35204435,4.54916667 C9.43780036,4.42041667 9.48067836,4.24875 9.39492236,4.12 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16.000000, -123.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.000000, 122.999582)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-bolt",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-bolt"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-bolt"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-bolt)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 10.3,
    height: 10.3
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolt);
export default __webpack_public_path__ + "static/media/bolt.7fed3e0fca4c09c39504cb5cdcb38ac6.svg";
export { ForwardRef as ReactComponent };